'use client';

import { FC, memo } from 'react';
import { Button } from '@mui/material';
import { useTranslations } from 'next-intl';
import { CardFooter } from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/styled';

interface WlasFiltersFooterProps {
  isDirty: boolean;
  isSaving: boolean;
  isInvalid?: boolean;
  onSave: () => void;
  onResetDefaults: () => void;
}

export const WlasFiltersFooter: FC<WlasFiltersFooterProps> = memo(
  ({ isDirty, isSaving, isInvalid, onSave, onResetDefaults }) => {
    const t = useTranslations('wlasWidget');

    return (
      <CardFooter>
        <Button
          variant="secondary"
          onClick={onSave}
          disabled={!isDirty || isSaving || isInvalid}
          sx={{ height: '38px', px: '18px' }}
        >
          {t('save')}
        </Button>
        <Button variant="text" onClick={onResetDefaults} sx={{ height: '38px', px: '18px' }}>
          {t('filters.resetDefaults')}
        </Button>
      </CardFooter>
    );
  },
);
WlasFiltersFooter.displayName = 'WlasFiltersFooter';
